import React, { memo } from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import {
  explorerFilterGridSx,
  getExplorerFilterChipSx,
} from "../explorerTheme";

export type ExplorerShadowChip = {
  key: string | number;
  label: string;
  selected: boolean;
  onClick: () => void;
};

type ExplorerShadowChipGridProps = {
  items: ExplorerShadowChip[];
  sx?: SxProps<Theme>;
};

const ExplorerShadowChipGrid: React.FC<ExplorerShadowChipGridProps> = ({
  items,
  sx,
}) => (
  <Box
    sx={
      (sx
        ? [explorerFilterGridSx, sx]
        : explorerFilterGridSx) as SxProps<Theme>
    }
  >
    {items.map((item) => (
      <Box
        key={item.key}
        component="button"
        type="button"
        onClick={item.onClick}
        sx={getExplorerFilterChipSx(item.selected)}
      >
        {item.label}
      </Box>
    ))}
  </Box>
);

export default memo(ExplorerShadowChipGrid);
